module.exports = __webpack_public_path__ + "static/media/work-in-progress.ed60c619.jpg";